import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=546b113e&scoped=true"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"
import style0 from "./AppSearch.vue?vue&type=style&index=0&id=546b113e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b113e",
  null
  
)

export default component.exports